import LandingPage from "@/componets/LandingLayout";
let pageSlug = "run-LP-V2";
const Run = () => {
  return <LandingPage page={pageSlug} />;
};
Run.hideLayout = true;
export default Run;
